// extracted by mini-css-extract-plugin
export default {"header":"SubscriptionSuccess_header__c1ct-","signOff":"SubscriptionSuccess_signOff__uuoQD"};